import db from '@/store/db';
import log from '@/logger';
import moment from 'moment';

export default {
  /**
   * DiaryEntry is replacement of legacy Diary implementation
   *
   */
  getDefaultDiaryEntry: (projectId) => {
    return {
      projectId: projectId,
      type: 'DiaryEntry',
      archived: false,

      createdAt: moment().format(),
      diaryDate: '',
      summary: '',
      currentUserId: '',
      highlightDate: false,
      noWorkPerformed: false,
      signedOff: false,
      performingCompanies: [
        // {
        //   "companyId": "",
        //   "diaryEntries": [
        //     {
        //       "numberOfWorkers": "",
        //       "comment": "",
        //     }
        //   ]
        // },
      ],
      unassigned: [],
    };
  },

  getDefaultDiaryEntryItem: () => {
    return {
      numberOfWorkers: null,
      comment: '',
    };
  },

  saveDiaryEntry: function (diaryEntry) {
    log.debug('DiaryEntryApi:saveDiaryEntry', [diaryEntry]);

    diaryEntry = Object.assign({}, this.getDefaultDiaryEntry(), diaryEntry);

    var savedDiaryEntry = {};
    if (diaryEntry._id) {
      return db.currentProjectDb.put(diaryEntry).then((response) => {
        savedDiaryEntry._rev = response.rev;
        return savedDiaryEntry;
      });
    } else {
      return db.currentProjectDb.post(diaryEntry).then((response) => {
        savedDiaryEntry._rev = response.rev;
        savedDiaryEntry._id = response.id;

        return savedDiaryEntry;
      });
    }
  },

  getDiaryEntries: function (projectId) {
    return db.currentProjectDb
      .query('diaryEntries', {
        include_docs: true,
        descending: false,
        startkey: [projectId, ''],
        endkey: [projectId, '\ufff0'],
      })
      .then((result) => {
        var populated = [];
        for (var row of result.rows) {
          var diaryEntry = Object.assign(this.getDefaultDiaryEntry(row.doc.projectId), row.doc);

          populated.push(diaryEntry);
        }

        return populated;
      })
      .catch(function (err) {
        log.error('Unable to load DiaryEntries', err);
        throw err;
      });
  },

  getDiaryEntry: function (id) {
    return db.currentProjectDb
      .get(id)
      .then((result) => {
        return result;
      })
      .catch(function (err) {
        log.error('Unable to load DiaryEntry', err);
        throw err;
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/diaryEntry/diaryEntryApi.js